// extracted by mini-css-extract-plugin
export var hl = "styles-module--hl--28b70";
export var icon = "styles-module--icon--fd404";
export var itemWrapper = "styles-module--itemWrapper--cb194";
export var left = "styles-module--left--705ac";
export var playBtn = "styles-module--playBtn--f8586";
export var right = "styles-module--right--ae2af";
export var text = "styles-module--text--cb243";
export var textContent = "styles-module--textContent--a5b00";